import { render, staticRenderFns } from "./About.vue?vue&type=template&id=17ff1e7c&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=17ff1e7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ff1e7c",
  null
  
)

export default component.exports